import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Chip,
  alpha,
  Tooltip,
} from '@mui/material';
import PaletteIcon from '@mui/icons-material/Palette';
import { colorThemes } from '../styles/landingThemeConfig';

const DevThemeSwitcher = ({ currentTheme, onThemeChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleThemeSelect = (themeName) => {
    onThemeChange(themeName);
    handleClose();
  };

  // Only show in development mode
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <>
      <Tooltip title="Theme Switcher (Dev Only)">
        <IconButton
          onClick={handleClick}
          sx={{
            position: 'fixed',
            top: 20,
            right: 20,
            zIndex: 9999,
            backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.9),
            backdropFilter: 'blur(10px)',
            border: (theme) => `1px solid ${theme.palette.divider}`,
            '&:hover': {
              backgroundColor: (theme) => alpha(theme.palette.background.paper, 1),
            },
          }}
        >
          <PaletteIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 200,
            backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.95),
            backdropFilter: 'blur(10px)',
          },
        }}
      >
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="caption" color="text.secondary">
            Color Theme (Dev Mode)
          </Typography>
        </Box>
        
        {Object.entries(colorThemes).map(([themeName, themeConfig]) => (
          <MenuItem
            key={themeName}
            onClick={() => handleThemeSelect(themeName)}
            selected={currentTheme === themeName}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              py: 1.5,
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: themeConfig.primary.main,
                border: '2px solid',
                borderColor: (theme) => theme.palette.divider,
              }}
            />
            <Box sx={{ flex: 1 }}>
              <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>
                {themeName}
              </Typography>
              {themeName === currentTheme && (
                <Typography variant="caption" color="primary">
                  Active
                </Typography>
              )}
            </Box>
            {themeName === 'purple' && (
              <Chip size="small" label="New" color="secondary" />
            )}
          </MenuItem>
        ))}
        
        <Box sx={{ px: 2, py: 1, mt: 1, borderTop: 1, borderColor: 'divider' }}>
          <Typography variant="caption" color="text.secondary">
            Theme changes are temporary and will reset on page reload
          </Typography>
        </Box>
      </Menu>
    </>
  );
};

export default DevThemeSwitcher;